
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateExternalProjectReferenceDtoFormGroup() {
return new FormGroup({
    tenantId: new FormControl<number | undefined>(undefined, [Validators.required]),
    externalProjectNumber: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
})
;
}
      